import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import EnterEmail from "./EnterEmail";
import ForgotOTP from "./ForgotOTP";
import ResetPassword from "./ResetPassword";
import { Illustration, IllustrationContainer, IllustrationDescription, IllustrationText, LoginContainer, LoginWrapper, Logo, LogoTopContainer } from "../../../styles/login";
import LoginImage from "../../../assets/svgs/LoginSignup/Login.svg";
import LogoImage from "../../../assets/svgs/LoginSignup/logo.svg";

const ForgotPassword: React.FC = () => {
  return (
    <>
     <LoginContainer>
            <LoginWrapper>
              <IllustrationContainer>
                <LogoTopContainer>
                  <Logo>
                    <img src={LogoImage} alt="LogoImage" />
                  </Logo>
                </LogoTopContainer>
                <Illustration src={LoginImage} alt="LoginImage" />
                <IllustrationText>
                  <IllustrationDescription>
                    Shop food, groceries, and services with ease - delivered
                    straight to you.
                  </IllustrationDescription>
                </IllustrationText>
              </IllustrationContainer>
    
              
    <Routes>
      <Route index element={<Navigate to="email" replace />} />
      <Route path="email" element={<EnterEmail />} />
      <Route path="otp" element={<ForgotOTP />} />
      <Route path="reset" element={<ResetPassword />} />
    </Routes>
            </LoginWrapper>
          </LoginContainer>
    </>
  );
};

export default ForgotPassword;
